import Error403 from './../pages/403.vue';
import Flash from './FlashUtils';
import Util from './Utils';

const RoutesUtils = {
    checkAuthPage: function(routeTo, routeFrom, resolve, reject) {
        var self = this;
        let user = RoutesUtils.getUser();
        if (!user || user == null) {
            reject();
            var loggedOut = Flash.get("logged-out");
            if(!loggedOut){
                // A este estado se llega al intentar entrar a un link interno de la aplicación antes de haber hecho login
                var directURL = window.location.href;
                Flash.set("directURL", directURL);
            }
            self.app.views.main.router.navigate("/login/");
        } else {
            resolve();
        }
    },
    checkAuth: function() {
        let user = RoutesUtils.getUser();
        if (!user || user == null) {
            return false;
        } else {
            return true;
        }
    },
    /**
     * `rolesDirectos` es opcional y solo lo usa quien lo necesita: ver `tieneAcceso`.
     */
    checkPermission: function(page, roles, Comp, props, rolesDirectos) {
        return function(routeTo, routeFrom, resolve, reject) {
            if (RoutesUtils.tieneAcceso(routeTo.path, roles, rolesDirectos)) {
                resolve({
                    component: Comp
                }, {
                    props: props
                });
            } else {
                resolve({ component: Error403 });
            }
        }
    },
    // Si una ruta cuelga de alguna entrada del menú cargado.
    isInMenu: function(menu, path) {
        const links = [];
        (menu.items || []).forEach(i => RoutesUtils.getLinksMenuItem(i, links));
        return links.filter(link => link && link != "/" && path.startsWith(link)).length > 0;
    },
    // Si el usuario puede entrar en una ruta. Manda el menú de Mongo, que es el control de acceso
    // real de las rutas; el listado de roles solo decide mientras el menú no esté cargado.
    // Lo usa checkPermission y también las pantallas que enlazan a otras, para no mandar a nadie a
    // un 403 con un enlace que se ve pinchable (revisión CODEX del PR #1707).
    //
    // `rolesDirectos` son los roles que entran aunque la ruta no cuelgue de su menú, y hacen
    // falta para las pantallas a las que se llega **enlazadas desde otra**: a la ficha de un
    // empleado la abre DIRECTOR desde el Mapa de aprobación, pero el módulo de empleados no
    // está en su menú, así que sin esto el enlace desaparecía y entrar a mano daba 403 en
    // cuanto el menú terminaba de cargar (revisión del PR #1711).
    tieneAcceso: function(path, roles, rolesDirectos) {
        var menu = Util.getMenu();
        if (!menu) {
            return RoutesUtils.checkRolesPermission(roles);
        }
        return path == "/" || path == "/perfil/" || path == "/index-offline/"
            || RoutesUtils.isInMenu(menu, path)
            || (!!rolesDirectos && RoutesUtils.checkRolesPermission(rolesDirectos));
    },
    /**
     * [#65, 02/10/2026] Aquí vivía `alCargarElMenu`: resolver el permiso con lo que hubiera y
     * revisarlo con un temporizador cuando apareciera el menú. Se ha retirado porque no podía
     * funcionar —`Utils.getMenu()` contesta al instante con el menú guardado de la sesión
     * anterior, así que la vigilancia terminaba antes de empezar— y porque la revisión posterior
     * sobra desde que las pantallas no se montan hasta tener el usuario de esta carga.
     *
     * Lo que hay ahora: `usuarioActualizado.js` (la pregunta, una sola vez) y
     * `barreraUsuarioActualizado.js` (la barrera de ruta que espera la respuesta antes de montar
     * nada). Decisión de diseño de Donchurru, 01/10/2026 en la incidencia #65.
     */
    public: function(Comp, props) {
        return function(routeTo, routeFrom, resolve, reject) {
            resolve({
                component: Comp
            }, {
                props: props
            });
        }
    },
    checkRolesPermission: function(roles) {
        var self = this;
        let user = RoutesUtils.getUser();
        if (!user || user == null || roles.filter(r => user.roles.indexOf(r) > -1).length <= 0 ) {
            return false;
        } 
        else {
            return true;
        }
    },
    getUser: function() {
        var user = localStorage.getItem("user");
        if (typeof user != "undefined" && user) {
            var userObj = JSON.parse(user);
            return userObj;
        }
        return null;
    },
    getLinksMenuItem: function(menuItem, hijos) {
        const self = this;
        if (!menuItem) {
            return [];
        }
        if (!hijos) {
            hijos = [];
        }
        hijos.push(menuItem.link)
        if (menuItem.hijos && menuItem.hijos.length) {
            menuItem.hijos.forEach(i => self.getLinksMenuItem(i, hijos));
        }
        return hijos;
    }
}

export default RoutesUtils;